'use strict';

module.exports = {
  exists: exists,
};

/**
 * Recursively checks to see if the key or key branch exists
 *
 * @param  {Object} options
 * @param  {String} key For branches separate keys with a '.' for example `parent.child`
 * @param  {Object} parents Subset of options (only used when checking branches)
 */
function exists (options, key, parents) {
  if (!options) {
    throw new Error('Missing options');
  } else {
    var props = key.split('.');
    var k = props.shift(); // key to check

    if (!options[k]) {
      if (parents) {
        throw new Error('Missing option: ' + [parents, k].join('.'));
      } else {
        throw new Error('Missing option: ' + k);
      }
    } else if (props.length) {
      props = props.join('.');
      parents = parents && [parents, k].join('.') || k;
      exists(options[k], props, parents); // recursively check the child properties
    }
  }
}


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/data/src/core/Validate.js